import { useRouter } from 'next/router'
import { PATHS } from '~shared/constants/paths'
import { cn } from '~shared/utils/cn'

type TCity = 'moscow' | 'almaty' | 'tashkent'

type TContactButtonsProps = {
  contacts: TCity[]
  activeContact: TCity
  setActiveContact: (contact: TCity) => void
}

const LABELS: Record<TCity, string> = {
  moscow: 'Москва',
  almaty: 'Алматы',
  tashkent: 'Ташкент'
}

export const ContactButtons = ({
  contacts,
  activeContact,
  setActiveContact
}: TContactButtonsProps) => {
  const router = useRouter()

  return (
    <div className='grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-[16px] md:gap-[32px] mb-[32px] 2lg:mb-[85px]'>
      {contacts.map((contact, idx) => {
        const isActive = contact === activeContact
        const isLastOdd = contacts.length % 2 !== 0 && idx === contacts.length - 1
        
        return (
          <a
            key={`ContactButtons__${contact}--${idx + 1}`}
            href={PATHS.front.contact.index}
            onClick={e => {
              e.preventDefault()
              setActiveContact(contact)
              router.push(PATHS.front.contact.index, undefined, {
                shallow: true
              })
            }}
            className={cn(
              'py-[10px] px-[16px] rounded-[8px] text-[18px] font-medium transition-colors cursor-pointer h-[55px] flex items-center justify-center w-full',
              // Адаптивное поведение для последнего нечётного элемента
              isLastOdd && 'sm:col-span-2 md:col-span-1',
              isActive
                ? 'bg-accent text-white'
                : 'bg-white text-acent border border-black/50 hover:border-accent duration-300 hover:text-accent hover:scale-[1.01]'
            )}>
            {LABELS[contact]}
          </a>
        )
      })}
    </div>
  )
}